module.exports = " <div class=row> <team-new></team-new> <div class=col-sm-5> <teams-list></teams-list> </div> <div class=col-sm-3> <team-selected></team-selected> </div> <div class=col-sm-4> <team-players></team-players> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/vue-html-loader!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuration/Team.vue
 ** module id = 310
 ** module chunks = 1
 **/